import { defineStore } from "pinia";
import Crud from "@/store/crud";
import CountryData from "@/store/country-data";
import { loadStat as loadStatCommon } from "@/tools/chartLoadStat";
import { useLK } from "@/controllerLK/LKstore";
import { toTimestamp } from "@/tools/date-time-tools";

/**
 * Общий helper для загрузки данных через loadCountryData
 */
function createLoadCountryDataHelper(contextThis) {
  return async (options) => {
    const lk = useLK();
    return await contextThis.loadCountryData({
      countryCode: lk.project.id,
      clear: true,
      ...options,
    });
  };
}

/**
 * Создает объект params с датами
 */
function createDateParams(dateFrom, dateTo) {
  if (!dateFrom) return {};
  return {
    dateStart: toTimestamp(dateFrom),
    dateEnd: toTimestamp(dateTo),
  };
}

/**
 * Создание стора для чартов
 */
export function createAnalyticsStore(id, endpoint, options = {}) {
  const {
    crudOptions = {},
    loadStatType = "common",
    customLoadStat = null,
  } = options;

  const crud = new Crud(
    process.env.VUE_APP_BASE_API + endpoint,
    "id",
    "",
    {},
    ...Object.values(crudOptions)
  );
  const countryData = new CountryData();

  // Различные варианты loadStat
  const loadStatVariants = {
    common: loadStatCommon,

    withBody: async function(dateFrom, dateTo, body = [], isFirstRequest = false) {
      if (!isFirstRequest && body.length === 0) {
        this.items = [];
        return false;
      }

      const loadData = createLoadCountryDataHelper(this);
      return await loadData({
        body,
        usePost: true,
        params: createDateParams(dateFrom, dateTo),
      });
    },

    withCategories: async function(dateFrom, dateTo, paramName, categoryIDs) {
      const params = new URLSearchParams();
      params.append("dateStart", toTimestamp(dateFrom));
      params.append("dateEnd", toTimestamp(dateTo));

      if (paramName && categoryIDs) {
        categoryIDs.forEach((id) => {
          params.append(paramName, id);
        });
      }

      const loadData = createLoadCountryDataHelper(this);
      return await loadData({ params });
    },

    sentiment: async function(body, dateFrom, dateTo) {
      const loadData = createLoadCountryDataHelper(this);
      return await loadData({
        body,
        usePost: true,
        params: createDateParams(dateFrom, dateTo),
      });
    },
  };

  return defineStore({
    id,
    state: () => ({
      ...crud.state,
      ...countryData.state,
    }),
    getters: {
      ...crud.getters,
      ...countryData.getters,
    },
    actions: {
      ...crud.actions,
      ...countryData.actions,
      loadStat: customLoadStat || loadStatVariants[loadStatType],
    },
  });
}
